export async function handleSubFieldPaste(event) {
  event.preventDefault();
  event.stopPropagation();

  const text = await getClipboardData(event);
  event.target.value += text;
  event.target.dispatchEvent(new Event('change', { bubbles: true }));
  event.target.dispatchEvent(new Event('input', { bubbles: true }));

  clearTextFromDivElement(event.target.parentNode);
}

/** Paste landed on a Tagify per-tag subfield (not the main mix surface). */
export function pasteTargetIsTagifyInnerField(domEvent) {
  const raw = domEvent.target;
  const el = raw?.nodeType === Node.TEXT_NODE ? raw.parentElement : raw;
  return Boolean(el?.closest?.('.tagify-inner-input'));
}

/**
 * If clipboard contains Tagify mix delimiters ({{ ... }}), returns current
 * serialized value + pasted text for tagify.loadOriginalValues to parse.
 * Otherwise null — caller keeps default paste. Tagify does the real parsing.
 *
 * @param {ClipboardEvent} domEvent
 * @param {string} currentSerialized — same format as the hidden field (buildInputValue)
 * @returns {string|null}
 */
export function mergedTagifyMixValueFromPaste(domEvent, currentSerialized) {
  const text = domEvent.clipboardData?.getData('text/plain') ?? '';
  if (!text.includes('{{') || !text.includes('}}')) return null;

  const current = currentSerialized ?? '';
  return `${current.replace(/\s+$/, '')}${text}`;
}

export async function handleSubFieldCopy(event) {
  setClipboardData(event, document.getSelection().toString());

  event.stopPropagation();
  event.preventDefault();
}

export async function setClipboardData(event, value) {
  if (navigator.clipboard == null) return;

  try {
    await navigator.clipboard.writeText(value);
  } catch (error) {
    event.clipboardData.setData('text/plain', value);
  }
}

export async function getClipboardData(event) {
  if (navigator.clipboard == null) return;

  try {
    return await navigator.clipboard.readText();
  } catch (error) {
    return (event.clipboardData || window.clipboardData).getData('Text');
  }
}

function clearTextFromDivElement(element) {
  if (element.childNodes.length) {
    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes[i].nodeType === 3) {
        element.removeChild(element.childNodes[i]);
      }
    }
  }
}
